import { BusinessOutlined } from '@mui/icons-material';
import { CuriosityNamespaceType } from '@procureai/curiosity-ui-mui';

import { SearchHitPurchaseOrder } from '../../components/SearchHitPurchaseOrder/SearchHitPurchaseOrder';
import { SearchRefinementListItemCuriosity } from '../../components/SearchRefinementListItemCuriosity/SearchRefinementListItemCuriosity';
import { SearchDateRange } from '../../filters/SearchDateRange/SearchDateRange';
import { SearchNumberRange } from '../../filters/SearchNumberRange/SearchNumberRange.tsx';
import { SearchRefinementList } from '../../filters/SearchRefinementList/SearchRefinementList';
import { SearchConfigItem } from '../../types/SearchConfigItem';
import { SearchFilterAttribute } from '../../types/SearchFilterAttribute';
import { SearchIndex } from '../../types/SearchIndex';
import { SearchIndexConfigFactoryOptions } from '../../types/SearchIndexConfigFactoryOptions';
import { createSearchFilterAttributeItem } from '../../util/createSearchFilterAttributeItem';
import { toNumberRangeRouteValue } from '../../util/mapStateToRoute.ts';
import { FacetVariant } from '~/routes/Search/types/FacetVariant.ts';
import { createSearchSortByItemValue } from '~/routes/Search/util/createSearchSortByItemValue.ts';

const indexName = SearchIndex.PURCHASE_ORDER;

export const purchaseOrderSearchIndexConfig = ({ t }: SearchIndexConfigFactoryOptions): SearchConfigItem => {
  return {
    title: t('indexes.purchaseOrder.title'),
    description: t('indexes.purchaseOrder.description'),
    icon: BusinessOutlined,
    indexName,
    slug: 'po',
    hitComponent: SearchHitPurchaseOrder,
    filters: [
      createSearchFilterAttributeItem({
        attribute: SearchFilterAttribute.PRICE_TOTAL,
        slug: 'price',
        facetVariant: FacetVariant.RANGE,
        component: SearchNumberRange,
        componentProps: {
          title: t('filter.priceTotal.title'),
        },
        valueStateToRoute: toNumberRangeRouteValue,
      }),
      createSearchFilterAttributeItem({
        attribute: SearchFilterAttribute.CREATED_AT,
        slug: 'created',
        facetVariant: FacetVariant.RANGE,
        componentProps: {
          title: t('filter.createdAt.title'),
        },
        component: SearchDateRange,
        valueStateToRoute: toNumberRangeRouteValue,
      }),
      createSearchFilterAttributeItem({
        attribute: SearchFilterAttribute.SUPPLIER_ID_PARENT,
        slug: 'supplier',
        facetVariant: FacetVariant.REFINEMENT_LIST,
        component: SearchRefinementList,
        componentProps: {
          title: t('filter.supplier.title'),
          itemComponent: SearchRefinementListItemCuriosity,
          itemComponentProps: {
            ns: CuriosityNamespaceType.SUPPLIER,
          },
        },
      }),
      createSearchFilterAttributeItem({
        attribute: SearchFilterAttribute.COMMODITY_GROUP_ID,
        slug: 'commodity-group',
        facetVariant: FacetVariant.REFINEMENT_LIST,
        component: SearchRefinementList,
        componentProps: {
          title: t('filter.commodityGroup.title'),
          itemComponent: SearchRefinementListItemCuriosity,
          itemComponentProps: {
            ns: CuriosityNamespaceType.COMMODITY_GROUP,
          },
        },
      }),
    ],
    sortByItems: [
      {
        label: t('sortBy.relevance'),
        value: createSearchSortByItemValue(indexName),
        slug: 'relevance',
        isDefault: true,
      },
      {
        label: t('sortBy.createdAtAsc'),
        value: createSearchSortByItemValue(indexName, SearchFilterAttribute.CREATED_AT),
        slug: 'created-at:asc',
      },
      {
        label: t('sortBy.createdAtDesc'),
        value: createSearchSortByItemValue(indexName, SearchFilterAttribute.CREATED_AT, true),
        slug: 'created-at:desc',
      },
      {
        label: t('sortBy.priceTotalAsc'),
        value: createSearchSortByItemValue(indexName, SearchFilterAttribute.PRICE_TOTAL),
        slug: 'price:asc',
      },
      {
        label: t('sortBy.priceTotalDesc'),
        value: createSearchSortByItemValue(indexName, SearchFilterAttribute.PRICE_TOTAL, true),
        slug: 'price:desc',
      },
      {
        label: t('sortBy.priceUnitAsc'),
        value: createSearchSortByItemValue(indexName, SearchFilterAttribute.PRICE_UNIT),
        slug: 'price-unit:asc',
      },
      {
        label: t('sortBy.priceUnitDesc'),
        value: createSearchSortByItemValue(indexName, SearchFilterAttribute.PRICE_UNIT, true),
        slug: 'price-unit:desc',
      },
    ],
  };
};
